import { type IconOptions, type IconAliases } from 'vuetify';

import { aliases as mdiAliases, mdi } from 'vuetify/iconsets/mdi';

import { customIcons } from './customIcons';
import { hugeIcons } from './hugeIcons';
import { vuetifyAlias } from './vuetifyIconAlias';

/**
 * Combined icon aliases.
 * Note: 'as any' is required because HugeIcons uses a custom VNode-like
 * SVG array [tag, attrs][] that differs from Vuetify's internal
 * [path, opacity][] type. The custom 'huge' set handles this translation.
 */
const mergedAliases: IconAliases = {
  ...mdiAliases,
  ...customIcons.aliases,
  ...hugeIcons.aliases,
  ...vuetifyAlias
} as any;

export const icons: IconOptions = {
  defaultSet: 'mdi',
  sets: {
    mdi,
    custom: customIcons.set,
    huge: hugeIcons.set
  },
  aliases: mergedAliases
};
